export { default } from './ToggleButton';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/ToggleButton/index.js
// module id = 389
// module chunks = 0